export default "__VITE_ASSET__B3$3WW3Z__"